const cookieValue = document.cookie
  .split('; ')
  .find((row) => row.startsWith('token='))?.split('=')[1];
const token = cookieValue === undefined ? process.env.REACT_APP_TEST_TOKEN : cookieValue;
export default token;
